import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import Pagination from "components/Pagination";
import Button from "components/UI/Button";
import EditSession from "./Modals/EditSession";
import SetPassword from "./Modals/SetPassword";
import AppliedPackages from "./Modals/AppliedPackages";
import AppliedPromos from "./Modals/AppliedPromos";
import { formatDate } from "../../../../common/Utils";
import { Constants } from "../../../../common/constants";
import ChangeEmail from "./Modals/ChangeEmail";

const access_level = localStorage.getItem("access_level");
const CURRENT_SESSION_TEXT = "Current Session";
const SESSION_HISTORY_TEXT = "Session History";
const CHECKIN_TIME_TEXT = "Checkin Time: ";
const CHECKOUT_TIME_TEXT = "Checkout Time: ";
const MINUTES_SPENT_TEXT = "Minutes Spend: ";
const COST_TEXT = "Cost: $";
const GYM_TEXT = "Gym: "
const DATE_TEXT = "Date: "
const EDIT_TEXT = "EDIT"
const CHECKOUT_TEXT = "CHECKOUT"

class SingleUser extends Component {
  state = {
    fetched: false,
    currentPage: 0,
    rowCount: Constants.DEFAULT_PAGINATION_COUNT,
    currentSession: {},
    showEditDialog: false,
    showSetPasswordDialog: false,
    showChangeMailDialog: false,
    showPackages: false,
    showPromos: false,
    editSession: {},
    packages: [],
    promos: [],
  };

  componentWillMount() {
    this.getSessionAPI();
    this.getAppliedPackages();
    this.getAppliedPromos();
  }

  getAppliedPackages = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/promos/active_packages/${localStorage.getItem(
          "flexitCurrentSingleUserID"
        )}`,
        {
          headers: {
            "x-access-token": access_token,
          },
        }
      )
      .then((res) => {
        this.setState({
          packages: res.data.data,
        });
      })
      .catch((err) => {
        ERROR_HANDLE(err);
      });
  };

  getAppliedPromos = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/promos/applied_promos/${localStorage.getItem(
          "flexitCurrentSingleUserID"
        )}`,
        {
          headers: {
            "x-access-token": access_token,
          },
        }
      )
      .then((res) => {
        this.setState({
          promos: res.data.data,
        });
      })
      .catch((err) => {
        ERROR_HANDLE(err);
      });
  };

  getSessionAPI() {
    const toastId = toast("Fetching User Data...");
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/admin/sessions/${localStorage.getItem(
          "flexitCurrentSingleUserID"
        )}`,
        {
          headers: {
            "x-access-token": access_token,
          }
        }
      )
      .then((res) => {
        toast.dismiss(toastId);
        this.setState(
          {
            ...this.state,
            fetched: true,
            data: res.data.data,
          },
          () => this.getCurrentSession()
        );
      })
      .catch((err) => {
        ERROR_HANDLE(err);
      });
  }

  getCurrentSession() {
    const data = this.state.data;
    if (
      data &&
      data.sessions &&
      data.sessions[0] &&
      data.sessions[0].checkout_time == null
    ) {
      let sessionArray = [...this.state.data.sessions]; // make a separate copy of the sessions
      sessionArray.splice(0, 1);
      this.setState({
        currentSession: this.state.data.sessions[0],
        data: {
          ...this.state.data,
          sessions: sessionArray,
        }
      });
    }
  }

  formatTime(date, zone) {
    if (date) {
      date = formatDate(date, zone);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    } else {
      return "--";
    }
  }

  /**
   * @description this is the props method gets handled from close action for the preview.
   *
   */
  close = () => {
    this.setState({
      showEditDialog: false,
      showSetPasswordDialog: false,
      showChangeMailDialog: false,
      showPackages: false,
      showPromos: false,
    });
  }

  /**
   * @description this is the props method gets handled from edit session component to update the session edited.
   * @param session - the session response received from edit session component
   */
  updateSession = (session) => {
    const data = this.state.data;
    if (data && data.sessions && data.sessions[0]) {
      let sessionArray = [...this.state.data.sessions]; // make a separate copy of the sessions
      sessionArray.forEach((sessionValue) => {
        if (sessionValue.id == session.id) {
          sessionValue.checkout_time = session.checkout_time;
          sessionValue.cost = session.cost / 100;
          sessionValue.minutes_spend = session.minutes_spend / (1000 * 60); //converting milliseconds to minutes.
        }
      });
      this.setState({
        data: {
          ...this.state.data,
          sessions: sessionArray,
        },
        showEditDialog: false,
      });
    }
  };

  /**
   * @description this is the props method gets handled from edit session component to update the current session.
   *
   */
  updateCurrentSession = () => {
    this.setState(
      {
        fetched: false,
        currentPage: 0,
        currentSession: {},
        showEditDialog: false,
        editSession: {},
      },
      () => this.getSessionAPI()
    );
  };

  renderSessionComponent(item, buttonTitle) {
    return (
      <div style={style.wrapper}>
        <div style={style.contentWrapper}>
          <p style={style.textContent}>
            {DATE_TEXT +
              formatDate(item.date, item.activity_timezone).toDateString()}
          </p>
          <p style={style.textContent}>{GYM_TEXT + item.gym}</p>
        </div>
        <div style={style.contentWrapper}>
          <p style={style.textContent}>
            {CHECKIN_TIME_TEXT}
            {`${this.formatTime(item.checkin_time, item.activity_timezone)}`}
          </p>
          <p style={style.textContent}>
            {CHECKOUT_TIME_TEXT}
            {item.checkout_time
              ? ` ${this.formatTime(
                  item.checkout_time,
                  item.activity_timezone
                )}`
              : ""}
          </p>
        </div>
        <div style={style.contentWrapper}>
          <p style={style.textContent}>
            {MINUTES_SPENT_TEXT + item.minutes_spend}
          </p>
          <p style={style.textContent}>{COST_TEXT + item.cost}</p>
        </div>
        <Button
          style={style.editButton}
          type="primary"
          onClick={() =>
            this.setState({
              editSession: item,
              showEditDialog: true,
            })
          }
        >
          {buttonTitle}
        </Button>
      </div>
    );
  }

  render() {
    const rowCount = parseInt(this.state.rowCount);
    const sessionHistory = this.state.fetched
      ? this.state.data.sessions.map((item, i) => {
          if (
            i >= this.state.currentPage * rowCount &&
            i < this.state.currentPage * rowCount + rowCount
          ) {
            return this.renderSessionComponent(item, EDIT_TEXT);
          }
        })
      : "";
    const currentSession = this.state.currentSession.checkin_time ? (
      <div style={style.body}>
        <p style={style.bodyTitle}>{CURRENT_SESSION_TEXT}</p>
        {this.renderSessionComponent(this.state.currentSession, CHECKOUT_TEXT)}
      </div>
    ) : (
      ""
    );

    return (
      <div>
        <div style={style.header}>
          <div style={style.actionContainer}>
            <Button
              holo
              type="holo"
              style={{ ...style.button, ...{ width: 200 } }}
              onClick={() => {
                this.setState({
                  showPromos: true,
                });
              }}
            >
              Add/Remove Promocode
            </Button>
            {this.state.packages && this.state.packages.length > 0 && (
              <Button
                holo
                type="holo"
                style={style.button}
                onClick={() => {
                  this.setState({
                    showPackages: true,
                  });
                }}
              >
                Show Packages
              </Button>
            )}
            <Button
              holo
              type="holo"
              style={style.button}
              onClick={() => {
                this.setState({ showChangeMailDialog: true });
              }}
            >
              Change Email
            </Button>
            <Button
              holo
              type="holo"
              style={style.button}
              onClick={() => {
                this.setState({ showSetPasswordDialog: true });
              }}
            >
              Change Password
            </Button>
            {access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_2 || access_level == Constants.ADMIN_ACCESS_LEVELS.TIER_3 ? null : (
              <Button
                holo
                type="holo"
                style={style.button}
                onClick={() => {
                  exportAllUsers();
                }}
              >
                Export
              </Button>
            )}
            <Button
              holo
              type="holo"
              style={{ ...style.button, ...{ width: 220 } }}
              onClick={exportWalletTransactions}
            >
              Export Wallet Transactions
            </Button>
          </div>
          <div style={style.profileWrapper}>
            {" "}
            <img
              src={
                this.state.fetched
                  ? this.state.data.profile_picture
                  : "https://via.placeholder.com/250"
              }
              alt="Picture"
              style={style.profilePic}
            />
            <p style={style.name}>
              {this.state.fetched ? this.state.data.name.full_name : ""}
            </p>
            <p style={style.email}>
              {this.state.fetched ? this.state.data.email : ""}
            </p>
            <p style={style.phone}>
              {this.state.fetched ? this.state.data.phone : ""}
            </p>
          </div>
          <div style={style.moreInfo}>
            <p style={style.moreInfoContent}>
              Gender: {this.state.fetched ? this.state.data.gender : ""}
            </p>
            <p style={style.moreInfoContent}>
              Birthday: {this.state.fetched ? this.state.data.birthday : ""}
            </p>
            <p style={style.moreInfoContent}>
              Joined:
              {this.state.fetched
                ? new Date(this.state.data.joined).toLocaleDateString()
                : ""}
            </p>
          </div>
          <div style={style.overview}>
            <p style={style.overviewContent}>
              Total Minutes:{" "}
              {this.state.fetched ? this.state.data.total_minutes : ""}
            </p>
            <p style={style.overviewContent}>
              Total Amount: $
              {this.state.fetched ? this.state.data.total_amount : ""}
            </p>
            <p style={style.overviewContent}>
              Wallet Balance: $
              {this.state.fetched
                ? this.state.data.wallet_amount.toFixed(2)
                : ""}
            </p>
            <p style={style.overviewContent}>
              Last Session:
              {this.state.fetched
                ? ` ${new Date(
                    this.state.data.last_session_date
                  ).toDateString()}`
                : ""}
            </p>
          </div>
        </div>
        {currentSession}
        <div style={style.body}>
          <p style={style.bodyTitle}>{SESSION_HISTORY_TEXT}</p>
          {sessionHistory}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {this.state.fetched ? (
            <Pagination
              currentPage={this.state.currentPage}
              pageCount={this.state.data.sessions.length / rowCount}
              rowCount={rowCount}
              pageAction={(pageNumber) => {
                this.setState({ ...this.state, currentPage: pageNumber });
              }}
              updateRowCount={(rowCount) =>
                this.setState({ rowCount, currentPage: 0 })
              }
            />
          ) : (
            ""
          )}
        </div>
        {this.state.showEditDialog && (
          <EditSession
            sessionId={this.state.editSession.id}
            checkInTime={formatDate(
              this.state.editSession.checkin_time,
              this.state.editSession.activity_timezone
            )}
            checkOutTime={formatDate(
              this.state.editSession.checkout_time,
              this.state.editSession.activity_timezone
            )}
            actualCheckoutTime={formatDate(
              this.state.editSession.actual_checkout,
              this.state.editSession.activity_timezone
            )}
            cost={this.state.editSession.cost}
            minutesSpent={this.state.editSession.minutes_spend}
            timeZone={this.state.editSession.activity_timezone}
            close={this.close}
            updateSession={(session) => this.updateSession(session)}
            updateCurrentSession={() => this.updateCurrentSession()}
          />
        )}
        {this.state.showChangeMailDialog && (
          <ChangeEmail
            email={this.state.data ? this.state.data.email : ""}
            close={this.close}
          />
        )}
        {this.state.showSetPasswordDialog && (
          <SetPassword
            email={this.state.data ? this.state.data.email : ""}
            close={this.close}
          />
        )}
        {this.state.showPackages && (
          <AppliedPackages
            refresh={() => this.getAppliedPackages()}
            packages={this.state.packages}
            close={this.close}
          />
        )}
        {this.state.showPromos && (
          <AppliedPromos
            refresh={() => this.getAppliedPromos()}
            packages={this.state.promos}
            close={this.close}
          />
        )}
      </div>
    );
  }
}
export default SingleUser;

const style = {
  header: {
    height: "350px",
    backgroundColor: "rgba(163, 163, 163, 0.18)",
    margin: "25px",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 2px 5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative"
  },
  body: {
    // height: "1250px",
    backgroundColor: "rgba(163, 163, 163, 0.18)",
    margin: "25px",
    marginBottom: "0px",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 2px 5px",
    padding: "25px 0px"
  },
  profileWrapper: { padding: "50px" },
  profilePic: {
    height: "200px",
    width: "200px",
    objectFit: "cover",
    borderRadius: "100%"
  },
  name: { fontSize: "32px", margin: "0px" },
  email: { fontSize: "20px", margin: "0px" },
  phone: { fontSize: "20px", margin: "0px" },
  moreInfo: { padding: "50px" },
  moreInfoContent: { textAlign: "left", fontSize: "26px" },
  overview: { padding: "50px", paddingTop: "100px" },
  overviewContent: { textAlign: "left", fontSize: "26px" },
  bodyTitle: { fontSize: "36px", marginTop: "0px" },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #ccc",
    margin: "10px 50px",
    padding: "20px",
    backgroundColor: "#e1e1e154"
  },
  textContent: {
    textAlign: "left",
    fontSize: "20px"
  },
  contentWrapper: {
    flex: 1,
    padding: "0px 25px"
  },
  editButton: {
    width: "150px",
    fontSize: "20px"
  },
  button: {
    flex: 1,
    width: 150,
    height: "40px",
    margin: "5px",
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #000",
    fontSize: "16px",
    borderRadius: "0px"
  },
  actionContainer: {
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    right: 0,
    alignItems: 'center',
  },
};

let exportAllUsers = () => {
  const access_token = localStorage.getItem("access_token");
  const toastId = toast("Exporting User Data...");
  axios
    .get(
      `${API_URL}/admin/export_sessions/${localStorage.getItem(
        "flexitCurrentSingleUserID"
      )}`,
      {
        headers: {
          "x-access-token": access_token
        }
      }
    )
    .then(res => {
      DOWNLOAD(res.data, "export.csv");
      toast.dismiss(toastId);
    })
    .catch(err => {
      ERROR_HANDLE(err);
    });
};

let exportWalletTransactions = () => {
  const access_token = localStorage.getItem("access_token");
  const toastId = toast("Exporting Wallet Transactions...");
  axios
    .get(
      `${API_URL}/admin/export/wallet_transactions/${localStorage.getItem(
        "flexitCurrentSingleUserID"
      )}`,
      {
        headers: {
          "x-access-token": access_token
        }
      }
    )
    .then(res => {
      DOWNLOAD(res.data, `wallet_transactions_${localStorage.getItem(
        "flexitCurrentSingleUserID")}.csv`);
      toast.dismiss(toastId);
    })
    .catch(err => {
      ERROR_HANDLE(err);
    });
};
